<template>
  <div>
    <!-- <div class="controlSidebar list-group" v-show="!isConfig && !autonomous"> -->
    <div class="controlSidebar list-group" v-show="!isConfig">
      <a href="#" class="list-group-item active">Supported Controls</a>
      <div id="sidebarControls">
        <a
          href="javascript:void(0)"
          class="list-group-item list-group-item-action control-wrapper"
          v-for="(obj, value) in controls"
          :key="value"
          :data-control-type="value"
        >
          <font-awesome-icon :icon="obj.icon" />
          {{obj.label}}
        </a>
      </div>
    </div>
    <div class="settingSidebar card" v-if="isConfig">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-6">
            <p>{{controlInfo.label}}</p>
          </div>
          <div class="col-md-6 text-right">
            <!-- <button class="btn btn-default btn-sm" @click="applyEditSidebar">Apply</button> -->
            <button class="btn btn-default btn-sm" @click="closeEditSidebar">Close</button>
          </div>
        </div>

        <base-config-component :control="controlInfo" :editSidebar="applyEditSidebar"></base-config-component>

        <component
          v-if="configComponent != null"
          :is="configComponent"
          :control="controlInfo"
          :editSidebar="applyEditSidebar"
        ></component>

        <base-style-component
          v-if="controlInfo.type != 'workflow'"
          :editSidebar="applyEditSidebar"
          :control="controlInfo"
        ></base-style-component>
      </div>
    </div>
  </div>
</template>

<script>
import { CONTROL_TYPES } from '@/components/DataGrid/FormBuilder/config/control_constant'
import {
  eventBus,
  EventHandlerConstant,
} from '@/components/DataGrid/FormBuilder/template/handler/event_handler'
import { ControlHandler } from '@/components/DataGrid/FormBuilder/template/handler/control_handler'
import { Hooks } from '@/components/DataGrid/FormBuilder/template/components/hook_lists'
import BaseConfigComponent from './sidebar_items/BaseConfigComponent'
import BaseStyleComponent from './sidebar_items/BaseStyleComponent'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    BaseStyleComponent,
    BaseConfigComponent,
    FontAwesomeIcon,
  },
  name: 'sidebar-component',
  data: () => ({
    controls: CONTROL_TYPES,
    isConfig: false,
    controlInfo: null,
    inheritedControlInfo: null,
    configComponent: null,
    autonomous: false,
  }),
  watch: {
    controlInfo: {
      deep: true,
      handler(value) {
        if (!value) {
          this.inheritedControlInfo = null
          return
        }

        const dInst = this.$instByClass(this, 'dashboard-component')
        const fbInst = this.$instByClass(this, 'form-builder-root')

        let form

        for (let gridId in dInst.inheritedData || {}) {
          const dashData = dInst.inheritedData[gridId]

          if (!dashData) continue
          if (!dashData.widgetsData) continue
          if (!dashData.widgetsData.dataGrid) continue
          if (!dashData.widgetsData.dataGrid[fbInst.gridId]) continue

          form =
            dashData.widgetsData.dataGrid[fbInst.gridId].rowEditorFieldsForm
          break
        }

        if (form) {
          this.inheritedControlInfo = this.$getDGFBControl(
            JSON.stringify(form),
            this.controlInfo.name,
            true
          )
        }
        // this.applyEditSidebar()
      },
    },
  },
  methods: {
    closeEditSidebar() {
      this.isConfig = false
      this.controlInfo = null
      ControlHandler.clearSelect()
    },
    applyEditSidebar() {
      if (this.controlInfo.name !== ControlHandler.getSelectedItem()) {
        return
      }

      // pre apply
      this.controlInfo.decimalPlace = parseInt(this.controlInfo.decimalPlace)

      // before hook here
      let b4Run = Hooks.Sidebar.beforeApplyConfig.runSequence(this.controlInfo)
      if (b4Run === false) {
        return
      }

      eventBus.$emit(
        EventHandlerConstant.ON_APPLY_EDITOR_SIDEBAR,
        this.controlInfo
      )

      // after hook here
      Hooks.Sidebar.afterApplyConfig.run(this.controlInfo)

      const message = "Don't forget to save your changes."

      this.$bvToast.toast(message, {
        title: 'Control settings applied!',
        variant: 'info',
        solid: true,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 2500,
      })
    },
    backToDefault(prop, value) {
      if (typeof value === 'undefined') {
        this.controlInfo[prop] = value
        delete this.controlInfo[prop]
      } else {
        this.controlInfo[prop] = value
      }
    },
  },
  created() {
    // catch event activate sidebar here
    eventBus.$on(EventHandlerConstant.ACTIVATE_EDITOR_SIDEBAR, controlInfo => {
      // before hook here
      let b4Run = Hooks.Sidebar.beforeOpenConfig.runSequence(controlInfo)
      if (b4Run === false) {
        return
      }

      // open config
      this.isConfig = true
      this.controlInfo = controlInfo
      this.configComponent = null

      // retrieve config component
      if (_.accessStr(this.controls[controlInfo.type], 'source.config')) {
        this.configComponent = this.controls[controlInfo.type].source.config
      }

      // after hook here
      Hooks.Sidebar.afterOpenConfig.run(this.controlInfo)
    })

    this.$nextTick(() => {
      let parentInst = this

      while (!$(parentInst.$el).hasClass('form-builder-root')) {
        parentInst = parentInst.$parent
      }

      this.autonomous = parentInst.autonomous
    })
  },
  mounted() {
    // console.log(this.controls, 'controls')
    // console.log(CONTROL_TYPES, 'types')
    // insert controls
    $('.list-group-item', $('#sidebarControls')).draggable({
      appendTo: 'body',
      containment: '',
      scroll: false,
      helper: 'clone',
      revert: 'invalid',
      zIndex: 9999,
      cancel: '.list-group-item-success',
      start: function(event, ui) {
        $(ui.helper).css('width', `${$(event.target).width()}px`)
      },
    })

    $(this.$el)
      .find('.controlSidebar')
      .droppable({
        accept: '.controlItemWrapper',
        drop: function(event, ui) {
          // remove control
          eventBus.$emit(EventHandlerConstant.REMOVE_CONTROL, ui)
        },
        over: function(event, ui) {
          ui.helper.css('border', '1px solid red')
        },
      })
  },
  beforeDestroy() {
    this.inheritedControlInfo = null
  },
}
</script>

<style scoped>
</style>
